import { useState, useEffect } from "react";
import { useFirestore } from "../../firebase-files/hooks/useFirestore";
import { useCollection } from "../../firebase-files/hooks/useCollection";
import { useAuthContext } from "../../firebase-files/hooks/useAuthContext";
const VendorContactDetails = ({ vendorProfileId }) => {
  const { user } = useAuthContext();

  const { documents: organisations } = useCollection("organisations");
  const vendorOrganisations = organisations?.find(
    (org) => org.organisationId === user?.organisationId
  );

  const { updateDocument } = useFirestore("organisations");

  const [isEditing, setIsEditing] = useState(false);
  const [isContactDetailSaving, setIsContactDetailSaving] = useState(false);
  const [saveContactDetailMessage, setSaveContactDetailMessage] = useState("");
  const [ContactDetailMessageType, setContactDetailMessageType] = useState("");

  const [contactDetailFormData, setcontactDetailFormData] = useState({
    primaryMail: "",
    primaryPhone: "",
    alternativeMail: "",
    alternativePhone: "",
  });

  // Update contactDetailFormData when vendorOrganisations changes
  useEffect(() => {
    if (vendorOrganisations) {
      setcontactDetailFormData({
        primaryMail: vendorOrganisations.contactDetail?.primaryMail || "",
        primaryPhone: vendorOrganisations.contactDetail?.primaryPhone || "",
        alternativeMail:
          vendorOrganisations.contactDetail?.alternativeMail || "",
        alternativePhone:
          vendorOrganisations.contactDetail?.alternativePhone || "",
      });
    }
  }, [vendorOrganisations]);

  const handleContactDetailCancelClick = () => {
    if (vendorOrganisations) {
      setcontactDetailFormData({
        primaryMail: vendorOrganisations.contactDetail?.primaryMail || "",
        primaryPhone: vendorOrganisations.contactDetail?.primaryPhone || "",
        alternativeMail:
          vendorOrganisations.contactDetail?.alternativeMail || "",
        alternativePhone:
          vendorOrganisations.contactDetail?.alternativePhone || "",
      });
    }
    setIsEditing(!isEditing);
  };

  // Handle Input Changes
  const handleContactDetailChange = (e) => {
    const { name, value } = e.target;
    setcontactDetailFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Validate Fields
  const validateContactDetailForm = () => {
    if (
      !contactDetailFormData.primaryPhone ||
      !contactDetailFormData.primaryMail ||
      !contactDetailFormData.alternativePhone ||
      !contactDetailFormData.alternativeMail
    ) {
      setSaveContactDetailMessage("Please fill all required fields.");
      setContactDetailMessageType("error_msg");
      setTimeout(() => {
        setSaveContactDetailMessage("");
        setContactDetailMessageType("");
      }, 4000);
      return false;
    }

    return true;
  };

  // Submit Form Data
  const handleContactDetailSubmit = async () => {
    if (!validateContactDetailForm()) return;

    setIsContactDetailSaving(true);
    setSaveContactDetailMessage("");

    try {
      const updatedData = {
        ...vendorOrganisations,
        contactDetail: contactDetailFormData,
      };

      await updateDocument(vendorProfileId, updatedData);
      setContactDetailMessageType("success_msg");
      setSaveContactDetailMessage("Updated successfully!");

      setTimeout(() => {
        setIsEditing(false);
      }, 4000);
    } catch (error) {
      console.error("Error updating contact details:", error);
      setContactDetailMessageType("error_msg");
      setSaveContactDetailMessage(
        "Failed to update contact details. Please try again."
      );
    } finally {
      setIsContactDetailSaving(false);
      setTimeout(() => {
        setSaveContactDetailMessage("");
        setContactDetailMessageType("");
      }, 4000);
    }
  };
  return (
    <div className="pd-cards animate-slide-in">
      <div className="pd-heading">
        <h2>Contact Detail</h2>
        {user &&
          vendorOrganisations &&
          vendorOrganisations.isApproved != true &&
          vendorOrganisations.isActive &&
          !isEditing && (
            <div
              className="pd-edit-state"
              onClick={() => {
                setIsEditing((prev) => !prev);
              }}
            >
              <span className="material-symbols-outlined">edit</span>
              Edit
            </div>
          )}
      </div>
      <div className="pd-data">
        {!isEditing && (
          <>
            <div className="pd-data-element">
              <div className="pd-icon">
                <img src="/assets/img/mobile-phone.png" alt="" />
              </div>
              <div className="pd-data-value">
                <h6>Primary Phone</h6>
                <p>
                  {vendorOrganisations?.contactDetail?.primaryPhone
                    ? vendorOrganisations.contactDetail.primaryPhone
                    : "Not provided yet"}
                </p>
              </div>
            </div>
            <div className="pd-data-element">
              <div className="pd-icon">
                <img src="/assets/img/mobile-phone.png" alt="" />
              </div>
              <div className="pd-data-value">
                <h6>Alternative Phone</h6>
                <p>
                  {vendorOrganisations?.contactDetail?.alternativePhone
                    ? vendorOrganisations.contactDetail.alternativePhone
                    : "Not provided yet"}
                </p>
              </div>
            </div>
            <br />
            <div className="pd-data-element">
              <div className="pd-icon">
                <img src="/assets/img/mail.png" alt="" />
              </div>
              <div className="pd-data-value">
                <h6>Primary Mail</h6>
                <p>
                  {vendorOrganisations?.contactDetail?.primaryMail
                    ? vendorOrganisations.contactDetail.primaryMail
                    : "Not provided yet"}
                </p>
              </div>
            </div>
            <div className="pd-data-element">
              <div className="pd-icon">
                <img src="/assets/img/mail.png" alt="" />
              </div>
              <div className="pd-data-value">
                <h6>Alternative Mail</h6>
                <p>
                  {vendorOrganisations?.contactDetail?.alternativeMail
                    ? vendorOrganisations.contactDetail.alternativeMail
                    : "Not provided yet"}
                </p>
              </div>
            </div>
          </>
        )}
        {isEditing && (
          <div className="col mb-4">
            <div className="row row_gap">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-field">
                  <label className="input-label required-field">
                    Primary Phone
                  </label>
                  <input
                    type="number"
                    name="primaryPhone"
                    value={contactDetailFormData.primaryPhone}
                    onChange={handleContactDetailChange}
                    required
                    placeholder="Type Primary Phone"
                    className="form-input"
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-field">
                  <label className="input-label required-field">
                    Alternative Phone
                  </label>
                  <input
                    type="number"
                    name="alternativePhone"
                    value={contactDetailFormData.alternativePhone}
                    onChange={handleContactDetailChange}
                    required
                    placeholder="Type Alternative Phone"
                    className="form-input"
                  />
                </div>
              </div>
            </div>
            <br />
            <div className="row row_gap">
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-field">
                  <label className="input-label required-field">
                    Primary Mail
                  </label>
                  <input
                    type="email"
                    name="primaryMail"
                    value={contactDetailFormData.primaryMail}
                    onChange={handleContactDetailChange}
                    required
                    placeholder="Type Primay Mail"
                    className="form-input"
                  />
                </div>
              </div>
              <div className="col-lg-4 col-md-6 col-sm-12">
                <div className="form-field">
                  <label className="input-label required-field">
                    Alternative Mail
                  </label>
                  <input
                    type="email"
                    name="alternativeMail"
                    value={contactDetailFormData.alternativeMail}
                    onChange={handleContactDetailChange}
                    required
                    placeholder="Type Alternative Mail"
                    className="form-input"
                  />
                </div>
              </div>
            </div>
            <div className="pd-edit-option">
              {saveContactDetailMessage && (
                <p className={`edit-msg_area ${ContactDetailMessageType}`}>
                  {saveContactDetailMessage}
                </p>
              )}

              <button
                onClick={handleContactDetailCancelClick}
                disabled={isContactDetailSaving}
                className={` pd-option-btn option-btn-cancel ${
                  isContactDetailSaving ? "disabled" : ""
                }`}
              >
                Cancel
              </button>
              <button
                onClick={handleContactDetailSubmit}
                disabled={isContactDetailSaving}
                className={` pd-option-btn option-btn-save ${
                  isContactDetailSaving ? "disabled" : ""
                }`}
              >
                {isContactDetailSaving ? "Saving..." : "Save"}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default VendorContactDetails;
